import { createListenerMiddleware } from '@reduxjs/toolkit'
import { initCartProductUpdateListener } from '@redux/listeners/cartProductUpdateListener'
import { initLocalFormStateListener } from '@redux/listeners/localFormStateListener'
import { initLocalCustomerContextStateListener } from '@redux/listeners/localCustomerContextStateListener'
import { initCartProductUpdateOnTokenFetchListener } from '@redux/listeners/cartProductUpdateListener/cartProductUpdateOnTokenFetchListener'

export const listenerMiddleware = createListenerMiddleware()

initCartProductUpdateOnTokenFetchListener(listenerMiddleware)
initCartProductUpdateListener(listenerMiddleware)
initLocalFormStateListener(listenerMiddleware)
initLocalCustomerContextStateListener(listenerMiddleware)
